export default {
  title: 'Galerij',
  sections: {
    logo: 'Logo',
    web_images: 'Galerij afbeeldingen online bestellen',
  },
  toasts: {
    image_uploaded: 'Wijzigingen succesvol opgeslagen',
    image_upload_failed: 'Wijzigingen opslaan mislukt',
  },
};
